import React, { useEffect, useState } from "react";
import { HiOutlineArrowUturnLeft } from "react-icons/hi2";
import "./RetrieveFunds.css";
import apiCall from "../../API/API";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const formatWalletName = (name) =>
  String(name || "")
    .split("_")
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");

const RetrieveFunds = () => {
  const [userName, setUserName] = useState("");
  const [amount, setAmount] = useState("");
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem("authToken");
  const [incomeData, setIncomeData] = useState([]);
  const [selectWallet, setSelectWallet] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!userName || !amount) {
      toast.error("Please fill in all fields");
      return;
    }

    setLoading(true);

    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: token,
        },
      };
      const { data, error } = await apiCall(
        "post",
        "/retrieve_fund",
        {
          amount: amount,
          username: userName,
          wallet_name: selectWallet,
        },
        config
      );

      if (data) {
        setUserName("");
        setAmount("");
        setSelectWallet("");
      } else if (error) {
        // toast.error(error.message || "An error occurred");
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "An error occurred");
    }
    setLoading(false);
  };

  var x = 0;

  useEffect(() => {
    if (x == 0) {
      fetchWallets();
      x++;
    }
  }, []);

  const fetchWallets = async () => {
    try {
      const { data } = await apiCall("get", "/retrieve_wallet");
      setIncomeData(data?.data);
    } catch (error) {
      console.log(error);
    }
  };

  const resetForm = () => {
    setUserName("");
    setAmount("");
    setSelectWallet("");
  };

  return (
    <section className="retrieve-funds">
      <div className="retrieve-funds__head">
        <h1>Retrieve Funds</h1>
        <p>Debit an amount from a user's wallet.</p>
      </div>

      <form className="retrieve-funds__card" onSubmit={handleSubmit}>
        <div className="retrieve-funds__card-head">
          <span className="retrieve-funds__icon" aria-hidden="true">
            <HiOutlineArrowUturnLeft />
          </span>
          <div>
            <h2>Fund retrieval</h2>
            <p>Amount is taken from the selected wallet.</p>
          </div>
        </div>

        <label className="retrieve-funds__field" htmlFor="userName">
          <span>Username</span>
          <input
            type="text"
            id="userName"
            className="form-control"
            value={userName}
            onChange={(e) => setUserName(e.target.value)}
            placeholder="Enter username"
            required
          />
        </label>

        <label className="retrieve-funds__field" htmlFor="walletType">
          <span>Wallet type</span>
          <select
            id="walletType"
            className="form-control"
            value={selectWallet}
            onChange={(e) => setSelectWallet(e.target.value)}
            required
          >
            <option value="">Select wallet</option>
            {Array.isArray(incomeData) &&
              incomeData.map((wallet, index) => (
                <option key={wallet?.wallet_name || index} value={wallet?.wallet_name}>
                  {formatWalletName(wallet?.wallet_name)}
                </option>
              ))}
          </select>
        </label>

        <label className="retrieve-funds__field" htmlFor="amount">
          <span>Amount</span>
          <input
            type="number"
            id="amount"
            className="form-control"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            placeholder="Enter amount"
            min="0"
            step="any"
            required
          />
        </label>

        <div className="retrieve-funds__actions">
          <button type="submit" className="retrieve-funds__submit" disabled={loading}>
            {loading ? "Submitting..." : "Submit"}
          </button>
          <button type="button" className="retrieve-funds__cancel" onClick={resetForm}>
            Cancel
          </button>
        </div>
      </form>
    </section>
  );
};

export default RetrieveFunds;
